import { Hero } from 'themes/organic/pages/OrganicHome/components/Hero/Hero';
import { Reviews } from 'themes/organic/pages/OrganicHome/components/Reviews/Reviews';
import { Services } from 'themes/organic/pages/OrganicHome/components/Services/Services';

import { useHomePage } from 'hooks/page/home/useHomePage';

import { GiftCard } from './components/GiftCard/GiftCard';

const OrganicHome = () => {
  const {
    bookNowLinkUrl,
    heroImageSrc,
    services,
    onServiceClick,
    pendingSelectService,
    onSelectServiceOption,
    onCloseServiceOption,
    currentReviewIndex,
    reviews,
    showNextReview,
    showPrevReview,
    aboutLink,
    areGiftCardsEnabled,
    showReviews,
  } = useHomePage();

  return (
    <>
      <Hero imgSrc={heroImageSrc} href={bookNowLinkUrl} />
      {services.length > 0 && (
        <Services
          onServiceClick={onServiceClick}
          pendingSelectService={pendingSelectService}
          onSelectServiceOption={onSelectServiceOption}
          onCloseServiceOption={onCloseServiceOption}
          services={services}
          href="/services"
        />
      )}
      {showReviews && (
        <Reviews
          currentReviewIndex={currentReviewIndex}
          onShowNextReview={showNextReview}
          onShowPrevReview={showPrevReview}
          reviews={reviews}
          aboutLink={aboutLink}
        />
      )}
      {areGiftCardsEnabled && <GiftCard />}
    </>
  );
};

export { OrganicHome };
